export enum StandardSpeed {
  SPEED = 'SPEED',
  CYCLE_TIME = 'CYCLE_TIME'
}
